// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../CountryUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../_metronic/_partials/controls";
import { useCountryUIContext } from "../CountryUIContext";

export function CountryTable({
  isLoading,
  countryListTotalCount,
  currentPage,
  setCurrentPage,
  // paginateCountryList,
  countryList,
}) {
  // Country UI Context
  const countryUIContext = useCountryUIContext();
  const countryUIProps = useMemo(() => {
    return {
      ids: countryUIContext.ids,
      setIds: countryUIContext.setIds,
      queryParams: countryUIContext.queryParams,
      setQueryParams: countryUIContext.setQueryParams,
      openReceiptDialog: countryUIContext.openReceiptDialog,
      openDeleteDialog: countryUIContext.openDeleteDialog,
      openEditDialog: countryUIContext.openEditDialog,
    };
  }, [countryUIContext]);

  // Table columns
  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   style: {
    //     minWidth: "110px",
    //   },
    // },
    {
      dataField: "name",
      text: "COUNTRY",
      sort: true,
      formatter: columnFormatters.CountryFormatter,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "country_code",
      text: "COUNTRY CODE",
      sort: true,
      formatter: columnFormatters.CountryCodeFormatter,
      sortCaret: sortCaret,
      style: {
        minWidth: "110px",
      },
    },
    {
      dataField: "status",
      text: "STATUS",
      formatter: columnFormatters.StatusTypeFormatter,
      style: {
        minWidth: "110px",
      },
    },
    // {
    //   dataField: "deleted_at",
    //   text: "Deleted",
    //   formatter: columnFormatters.DeleteTypeFormatter,
    //   style: {
    //     minWidth: "110px",
    //   },
    // },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openReceiptDialog: countryUIProps.openReceiptDialog,
        openDeleteDialog: countryUIProps.openDeleteDialog,
        openEditDialog: countryUIProps.openEditDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: countryListTotalCount ? countryListTotalCount : 0,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: countryUIProps.queryParams.pageSize,
    page: currentPage,
    onPageChange: (page) => {
      if (page === 0) return;
      setCurrentPage(page);
      // paginateCountryList(page);
    },
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination isLoading={isLoading} paginationProps={paginationProps}>
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-head-bg table-borderless table-vertical-center country-table"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={countryList === null ? [] : countryList}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  countryUIProps.setQueryParams
                )}
                {...paginationTableProps}
              ></BootstrapTable>
              <PleaseWaitMessage isLoading={isLoading} />
              <NoRecordsFoundMessage
                entities={countryList}
                errorMessage={"No countries found!"}
              />
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
